var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTm2Logo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 67,
    viewBox: "0 0 68 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 66H68V0H0V66ZM2.02028 63.9851H65.9804V2.0149H2.02028V63.9851Z",
    fill: "#555"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.8161 35H28.777H28.0672H27.7502L23.496 46.3108L19.2418 35H18.9201H18.215H16.1866H14V53H18.223V42.5166L22.3815 53H24.6298L28.777 42.4443V53H33V35H30.8161Z",
    fill: "#555"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.6948 49.3875C41.8623 49.2162 42.081 49.0409 42.3529 48.8609C42.8878 48.5056 43.5351 48.1921 44.2935 47.919L48.7452 46.2961C49.6267 46.0237 50.379 45.7385 51.0014 45.4412C51.6238 45.1438 52.2132 44.7723 52.7697 44.326C53.3255 43.8803 53.744 43.3315 54.0246 42.6788C54.3046 42.0262 54.4445 41.2865 54.4445 40.4613C54.4445 39.4452 54.2393 38.5774 53.8261 37.8587C53.4143 37.1406 52.802 36.579 51.9905 36.1738C51.1784 35.7699 50.2538 35.478 49.2149 35.3C48.176 35.1233 46.9641 35.0343 45.5793 35.0343C39.6775 35.0262 36.6233 37.2647 36.4167 41.7491H41.2029C41.252 41.1301 41.4061 40.5907 41.6659 40.1322C41.9256 39.6744 42.2721 39.3231 42.7048 39.0797C43.1374 38.8357 43.6011 38.6583 44.0956 38.5464C44.5902 38.4352 45.1265 38.3799 45.7031 38.3799C48.3079 38.3799 49.6105 39.1148 49.6105 40.5846C49.6105 41.2285 49.369 41.7491 48.8865 42.1455C48.4054 42.5426 47.6484 42.9512 46.6176 43.3719L42.8225 44.9213C42.1133 45.2106 41.5098 45.4722 41.0105 45.7082C40.5119 45.9435 39.9372 46.286 39.2859 46.7357C38.6345 47.1861 38.107 47.6648 37.7033 48.1732C37.2995 48.6816 36.953 49.3234 36.6644 50.1002C36.3764 50.8762 36.2317 51.7392 36.2317 52.6892V53.2219H38.362H54.5192V49.877V49.3875H41.6948Z",
    fill: "#555"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5002 14.021V17.5917V17.8554H20.9712V31.5997H25.242V17.8554H32.7365V17.5917V14.021H13.5002Z",
    fill: "#555"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.2382 14.0144C51.2631 14.0144 50.4685 14.81 50.4685 15.7884C50.4685 16.766 51.2631 17.5616 52.2382 17.5616C53.2138 17.5616 54.0078 16.766 54.0078 15.7884C54.0078 14.81 53.2138 14.0144 52.2382 14.0144ZM52.2382 18.074C50.9812 18.074 49.9578 17.0485 49.9578 15.7884C49.9578 14.5282 50.9812 13.5027 52.2382 13.5027C53.4958 13.5027 54.5192 14.5282 54.5192 15.7884C54.5192 17.0485 53.4958 18.074 52.2382 18.074Z",
    fill: "#555"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.9732 15.2687V15.6342H52.3117C52.4617 15.6342 52.5532 15.5748 52.5532 15.4501C52.5532 15.3254 52.4584 15.2687 52.3117 15.2687H51.9732ZM52.3171 14.8898C52.7477 14.8898 52.9771 15.1049 52.9771 15.4501C52.9771 15.7272 52.8022 15.9221 52.4907 15.9719L52.9913 16.6401H52.4947L52.0344 15.9848H51.9732V16.6401H51.5574V14.8898H52.3171Z",
    fill: "#555"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTm2Logo);
export default __webpack_public_path__ + "static/media/tm2-logo.652890c4ac4531e5bd7fa9a586490795.svg";
export { ForwardRef as ReactComponent };